import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../selectors/users';
import {
  getModuleType,
  getModuleMeta,
  getModuleVersion,
} from '../../../../selectors/modules';
import { getCanCurrentUserEditModule } from '../../../../selectors/layout';

import { updateModule } from '../../../../actions/modules';
import { Props } from './WidgetBoxWide';

export type ConnectedKeys =
  | 'profileOwnerId'
  | 'isCurrentUserProfileOwner'
  | 'moduleType'
  | 'moduleVersion'
  | 'canUserEditWidget'
  | 'isNewlyAddedModule';
export type StateProps = Pick<Props, ConnectedKeys>;
export type DispatchProps = Pick<Props, 'updateModule'>;
export type OwnProps = Without<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => ({
  isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
  profileOwnerId: getProfileOwnerUser(state).userId,
  moduleType: getModuleType(state, ownProps.moduleId),
  moduleVersion: getModuleVersion(state, ownProps.moduleId),
  isNewlyAddedModule: getModuleMeta(state, ownProps.moduleId).isNewlyAdded,
  canUserEditWidget: getCanCurrentUserEditModule(
    state,
    ownProps.section,
    ownProps.zone,
    ownProps.moduleId
  ),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  updateModule,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
);
